'use strict';

import ngFitText from 'ng-fittext';
import animation from 'angular-animate';
import ngSanitize from 'angular-sanitize';
import ngMessages from 'angular-messages';
import ngRipple from 'ng-ripple';
// import dropdown from 'angular-ui-bootstrap/src/dropdown/index-nocss';

/**
 * @ngdoc overview
 * @name simpleAppApp
 * @description
 * # simpleAppApp
 *
 * Main module of the application.
 */
const techpadModule = angular.module('techpad', [
  'ionic',
  'timer',
  ngMessages,
  animation,
  ngSanitize,
  'ngFitText',
  'ionic-datepicker',
  'ion-autocomplete',
  'ngRipple',
  'ui.select',
  'angularjs-dropdown-multiselect'
]);

require('./partials');

export const module = techpadModule;


// WEBPACK FOOTER //
// ./src/scripts/app.js